import { api } from "./client";
import type { LayoutOut, LayoutPayload } from "@/types/api";

export function getLayout(pageKey: string) {
  return api.get<LayoutOut>(`/api/layouts/${pageKey}`);
}

export function saveLayout(pageKey: string, payload: LayoutPayload) {
  return api.put<LayoutOut>(`/api/layouts/${pageKey}`, payload);
}

export function resetLayout(pageKey: string) {
  return api.del<void>(`/api/layouts/${pageKey}`);
}
